import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import { AuthHttp } from '../core/auth-http.service';


@Injectable()
export class HomeService {

constructor(private http: AuthHttp) {
}

getOfferWindow() {
return this.http.get('prd/offer/view/window/1/4')
.map(response => response.json() );
}


setSessionData() {
  return this.http.get('user/sessionData')
  .map(response => response.json());
}

}



// WEBPACK FOOTER //
// ./src/app/home/home.service.ts